export default "__VITE_ASSET__Crm71gPx__"